import React from "react";
import styles from "./SignupQuick.module.css";
import { ReactComponent as Logo } from "./../../graphics/images/leagueLogo.svg";
import SignupQuickForm from "./SignupForm/SignupQuickForm";
import FooterSignupQuickSteps from "./FooterSteps/FooterSignupQuickSteps";

function SignupQuick(props) {
  const { user, setUser, stage, invited } = props;

  const [isFixedCss, setIsFixedCss] = React.useState(false);

  return (
    <div className={styles.signup}>
      {/* {isFixedCss ? <span>Amit</span> : <span>none</span>} */}
      <Logo width="55vw" />
      <SignupQuickForm
        user={user}
        setUser={setUser}
        stage={stage}
        isFixedCss={isFixedCss}
        setIsFixedCss={setIsFixedCss}
        invited={invited}
      />
    </div>
  );
}

export default SignupQuick;
